import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import PrivacyPolicyModal from './PrivacyPolicyModal';
import GetStartedModal from './GetStartedModal';
import FooterSection from './FooterSection';
import { mockData } from '../mock';

const Layout = ({ children }) => {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showGetStartedModal, setShowGetStartedModal] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;
  const isServicesActive = location.pathname === '/services' || location.pathname.startsWith('/services/') || location.pathname.startsWith('/get-started') || location.pathname === '/mutual-funds';

  return (
    <div className="home-container">
      <PrivacyPolicyModal isOpen={showPrivacyPolicy} onClose={() => setShowPrivacyPolicy(false)} />
      <GetStartedModal isOpen={showGetStartedModal} onClose={() => setShowGetStartedModal(false)} />

      <header className="dark-header" data-testid="header">
        <div className="header-content">
          <Link to="/" className="logo-container" style={{ textDecoration: 'none' }}>
            <img
              src="https://customer-assets.emergentagent.com/job_asset-planner-3/artifacts/o1athb2x_apk%20fintech%20logo%20png%20file%20%289%29.png"
              alt="APK FINTECH Logo"
              className="logo-image"
            />
            <div className="logo-text">APK FINTECH</div>
          </Link>
          <nav className="dark-nav">
            <Link to="/" className={`dark-nav-link ${isActive('/') ? 'nav-active' : ''}`}>Home</Link>
            <Link to="/about" className={`dark-nav-link ${isActive('/about') ? 'nav-active' : ''}`}>The APK Advantage</Link>

            {/* Services Dropdown */}
            <div
              className="nav-dropdown-wrapper"
              onMouseEnter={() => setServicesOpen(true)}
              onMouseLeave={() => setServicesOpen(false)}
            >
              <Link
                to="/services"
                className={`dark-nav-link nav-dropdown-trigger ${isServicesActive ? 'nav-active' : ''}`}
                data-testid="services-dropdown-trigger"
              >
                Services <ChevronDown size={14} className={`dropdown-chevron ${servicesOpen ? 'open' : ''}`} />
              </Link>
              {servicesOpen && (
                <div className="nav-dropdown-menu" data-testid="services-dropdown-menu">
                  <Link
                    to="/mutual-funds"
                    className="nav-dropdown-item"
                    data-testid="dropdown-item-mutual-funds"
                    onClick={() => setServicesOpen(false)}
                  >
                    Mutual Funds
                  </Link>
                  {mockData.serviceCategories
                    .filter((cat) => cat.slug !== 'mutual-funds')
                    .map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/services/${cat.slug}`}
                      className="nav-dropdown-item"
                      data-testid={`dropdown-item-${cat.slug}`}
                      onClick={() => setServicesOpen(false)}
                    >
                      {cat.title}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link to="/testimonials" className={`dark-nav-link ${isActive('/testimonials') ? 'nav-active' : ''}`}>Client Stories</Link>
            <a
              href="https://apkfintech.my-portfolio.co.in/app/#/login"
              target="_blank"
              rel="noopener noreferrer"
              className="dark-nav-link"
            >
              Portfolio Tracker
            </a>
            <Link to="/contact" className={`dark-nav-link ${isActive('/contact') ? 'nav-active' : ''}`}>Contact</Link>
          </nav>
        </div>
      </header>

      <main className="page-main">
        {typeof children === 'function'
          ? children({ setShowGetStartedModal })
          : children}
      </main>

      <FooterSection onShowPrivacyPolicy={() => setShowPrivacyPolicy(true)} />
    </div>
  );
};

export default Layout;
